import { createRootRoute, Outlet } from "@tanstack/react-router";

import NotFoundPage from "@/components/pages/NotFoundPage";
import { Toaster } from "@/components/ui/sonner";

import Providers from "../components/providers";

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
});

function RootComponent() {
  return (
    <Providers>
      <Outlet />
      <Toaster />
    </Providers>
  );
}
